import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const Image = ({ src, fixed, width, height }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: allFile(filter: {relativeDirectory: {eq: "highlightblocks"}}) {
        edges {
          node {
            childImageSharp {
              fluid(maxWidth: 300) {
                originalName
                ...GatsbyImageSharpFluid
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  const file = data.placeholderImage.edges.find(({ node }) => node.childImageSharp.fluid.originalName === src)
  if (file) {
    return <Img fluid={file.node.childImageSharp.fluid} />
  }

  return ''
}

export default Image
